import React, { createContext, useState, ReactNode } from 'react';

interface LoginContextProviderProps {
	isLogged: boolean;
	setIsLogged: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoginContext = createContext<LoginContextProviderProps>({
	isLogged: true,
	setIsLogged: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function LoginContextProvider({ children }: ContextProps) {
	const [isLogged, setIsLogged] = useState(false);

	return (
		<LoginContext.Provider value={{ isLogged, setIsLogged }}>
			{children}
		</LoginContext.Provider>
	);
}

export default LoginContext;
